/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as DevRouteRouteImport } from './routes/dev/route'
import { Route as WorkspaceSlugRouteRouteImport } from './routes/$workspaceSlug/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DevIndexRouteImport } from './routes/dev/index'
import { Route as WorkspaceSlugIndexRouteImport } from './routes/$workspaceSlug/index'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as DevNotificationsRouteImport } from './routes/dev/notifications'
import { Route as DevDocumentsRouteImport } from './routes/dev/documents'
import { Route as DevChecklistRouteImport } from './routes/dev/checklist'
import { Route as DevAuditsRouteImport } from './routes/dev/audits'
import { Route as WorkspaceSlugInboxRouteImport } from './routes/$workspaceSlug/inbox'
import { Route as WorkspaceSlugDashboardRouteImport } from './routes/$workspaceSlug/dashboard'
import { Route as WorkspaceSlugSettingsRouteRouteImport } from './routes/$workspaceSlug/settings/route'
import { Route as WorkspaceSlugDocumentsRouteRouteImport } from './routes/$workspaceSlug/documents/route'
import { Route as WorkspaceSlugAuditsRouteRouteImport } from './routes/$workspaceSlug/audits/route'
import { Route as WorkspaceSlugAdminRouteRouteImport } from './routes/$workspaceSlug/admin/route'
import { Route as WorkspaceSlugStandardsIndexRouteImport } from './routes/$workspaceSlug/standards/index'
import { Route as WorkspaceSlugSettingsIndexRouteImport } from './routes/$workspaceSlug/settings/index'
import { Route as WorkspaceSlugReportsIndexRouteImport } from './routes/$workspaceSlug/reports/index'
import { Route as WorkspaceSlugDocumentsIndexRouteImport } from './routes/$workspaceSlug/documents/index'
import { Route as WorkspaceSlugAuditsIndexRouteImport } from './routes/$workspaceSlug/audits/index'
import { Route as WorkspaceSlugStandardsStandardIdRouteImport } from './routes/$workspaceSlug/standards/$standardId'
import { Route as WorkspaceSlugSettingsWorkspaceRouteImport } from './routes/$workspaceSlug/settings/workspace'
import { Route as WorkspaceSlugSettingsTagsRouteImport } from './routes/$workspaceSlug/settings/tags'
import { Route as WorkspaceSlugSettingsSecurityRouteImport } from './routes/$workspaceSlug/settings/security'
import { Route as WorkspaceSlugSettingsProfileRouteImport } from './routes/$workspaceSlug/settings/profile'
import { Route as WorkspaceSlugSettingsNotificationsRouteImport } from './routes/$workspaceSlug/settings/notifications'
import { Route as WorkspaceSlugSettingsIntegrationsRouteImport } from './routes/$workspaceSlug/settings/integrations'
import { Route as WorkspaceSlugSettingsCategoriesRouteImport } from './routes/$workspaceSlug/settings/categories'
import { Route as WorkspaceSlugSettingsBillingRouteImport } from './routes/$workspaceSlug/settings/billing'
import { Route as WorkspaceSlugSettingsAuditTagsRouteImport } from './routes/$workspaceSlug/settings/audit-tags'
import { Route as WorkspaceSlugSettingsAuditConfigRouteImport } from './routes/$workspaceSlug/settings/audit-config'
import { Route as WorkspaceSlugSettingsAiUsageRouteImport } from './routes/$workspaceSlug/settings/ai-usage'
import { Route as WorkspaceSlugSettingsAiRulesRouteImport } from './routes/$workspaceSlug/settings/ai-rules'
import { Route as WorkspaceSlugSettingsAiProviderRouteImport } from './routes/$workspaceSlug/settings/ai-provider'
import { Route as WorkspaceSlugDocumentsDocumentIdRouteImport } from './routes/$workspaceSlug/documents/$documentId'
import { Route as WorkspaceSlugAuditsNewRouteRouteImport } from './routes/$workspaceSlug/audits/new/route'
import { Route as WorkspaceSlugAuditsAuditIdRouteRouteImport } from './routes/$workspaceSlug/audits/$auditId/route'
import { Route as WorkspaceSlugAdminActionsRouteRouteImport } from './routes/$workspaceSlug/admin/actions/route'
import { Route as WorkspaceSlugAuditsNewIndexRouteImport } from './routes/$workspaceSlug/audits/new/index'
import { Route as WorkspaceSlugAuditsAuditIdIndexRouteImport } from './routes/$workspaceSlug/audits/$auditId/index'
import { Route as WorkspaceSlugAdminStandardsIndexRouteImport } from './routes/$workspaceSlug/admin/standards/index'
import { Route as WorkspaceSlugAdminActionsIndexRouteImport } from './routes/$workspaceSlug/admin/actions/index'
import { Route as WorkspaceSlugAdminStandardsStandardIdRouteImport } from './routes/$workspaceSlug/admin/standards/$standardId'
import { Route as WorkspaceSlugAuditsAuditIdChecklistIndexRouteImport } from './routes/$workspaceSlug/audits/$auditId/checklist/index'

const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRouteRoute = DevRouteRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceSlugRouteRoute = WorkspaceSlugRouteRouteImport.update({
  id: '/$workspaceSlug',
  path: '/$workspaceSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevIndexRoute = DevIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DevRouteRoute,
} as any)
const WorkspaceSlugIndexRoute = WorkspaceSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkspaceSlugRouteRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DevNotificationsRoute = DevNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => DevRouteRoute,
} as any)
const DevDocumentsRoute = DevDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => DevRouteRoute,
} as any)
const DevChecklistRoute = DevChecklistRouteImport.update({
  id: '/checklist',
  path: '/checklist',
  getParentRoute: () => DevRouteRoute,
} as any)
const DevAuditsRoute = DevAuditsRouteImport.update({
  id: '/audits',
  path: '/audits',
  getParentRoute: () => DevRouteRoute,
} as any)
const WorkspaceSlugInboxRoute = WorkspaceSlugInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => WorkspaceSlugRouteRoute,
} as any)
const WorkspaceSlugDashboardRoute = WorkspaceSlugDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => WorkspaceSlugRouteRoute,
} as any)
const WorkspaceSlugSettingsRouteRoute =
  WorkspaceSlugSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => WorkspaceSlugRouteRoute,
  } as any)
const WorkspaceSlugDocumentsRouteRoute =
  WorkspaceSlugDocumentsRouteRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => WorkspaceSlugRouteRoute,
  } as any)
const WorkspaceSlugAuditsRouteRoute =
  WorkspaceSlugAuditsRouteRouteImport.update({
    id: '/audits',
    path: '/audits',
    getParentRoute: () => WorkspaceSlugRouteRoute,
  } as any)
const WorkspaceSlugAdminRouteRoute = WorkspaceSlugAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => WorkspaceSlugRouteRoute,
} as any)
const WorkspaceSlugStandardsIndexRoute =
  WorkspaceSlugStandardsIndexRouteImport.update({
    id: '/standards/',
    path: '/standards/',
    getParentRoute: () => WorkspaceSlugRouteRoute,
  } as any)
const WorkspaceSlugSettingsIndexRoute =
  WorkspaceSlugSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceSlugReportsIndexRoute =
  WorkspaceSlugReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => WorkspaceSlugRouteRoute,
  } as any)
const WorkspaceSlugDocumentsIndexRoute =
  WorkspaceSlugDocumentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceSlugDocumentsRouteRoute,
  } as any)
const WorkspaceSlugAuditsIndexRoute =
  WorkspaceSlugAuditsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceSlugAuditsRouteRoute,
  } as any)
const WorkspaceSlugStandardsStandardIdRoute =
  WorkspaceSlugStandardsStandardIdRouteImport.update({
    id: '/standards/$standardId',
    path: '/standards/$standardId',
    getParentRoute: () => WorkspaceSlugRouteRoute,
  } as any)
const WorkspaceSlugSettingsWorkspaceRoute =
  WorkspaceSlugSettingsWorkspaceRouteImport.update({
    id: '/workspace',
    path: '/workspace',
    getParentRoute: () => WorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceSlugSettingsTagsRoute =
  WorkspaceSlugSettingsTagsRouteImport.update({
    id: '/tags',
    path: '/tags',
    getParentRoute: () => WorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceSlugSettingsSecurityRoute =
  WorkspaceSlugSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => WorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceSlugSettingsProfileRoute =
  WorkspaceSlugSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => WorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceSlugSettingsNotificationsRoute =
  WorkspaceSlugSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => WorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceSlugSettingsIntegrationsRoute =
  WorkspaceSlugSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => WorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceSlugSettingsCategoriesRoute =
  WorkspaceSlugSettingsCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => WorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceSlugSettingsBillingRoute =
  WorkspaceSlugSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => WorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceSlugSettingsAuditTagsRoute =
  WorkspaceSlugSettingsAuditTagsRouteImport.update({
    id: '/audit-tags',
    path: '/audit-tags',
    getParentRoute: () => WorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceSlugSettingsAuditConfigRoute =
  WorkspaceSlugSettingsAuditConfigRouteImport.update({
    id: '/audit-config',
    path: '/audit-config',
    getParentRoute: () => WorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceSlugSettingsAiUsageRoute =
  WorkspaceSlugSettingsAiUsageRouteImport.update({
    id: '/ai-usage',
    path: '/ai-usage',
    getParentRoute: () => WorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceSlugSettingsAiRulesRoute =
  WorkspaceSlugSettingsAiRulesRouteImport.update({
    id: '/ai-rules',
    path: '/ai-rules',
    getParentRoute: () => WorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceSlugSettingsAiProviderRoute =
  WorkspaceSlugSettingsAiProviderRouteImport.update({
    id: '/ai-provider',
    path: '/ai-provider',
    getParentRoute: () => WorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceSlugDocumentsDocumentIdRoute =
  WorkspaceSlugDocumentsDocumentIdRouteImport.update({
    id: '/$documentId',
    path: '/$documentId',
    getParentRoute: () => WorkspaceSlugDocumentsRouteRoute,
  } as any)
const WorkspaceSlugAuditsNewRouteRoute =
  WorkspaceSlugAuditsNewRouteRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => WorkspaceSlugAuditsRouteRoute,
  } as any)
const WorkspaceSlugAuditsAuditIdRouteRoute =
  WorkspaceSlugAuditsAuditIdRouteRouteImport.update({
    id: '/$auditId',
    path: '/$auditId',
    getParentRoute: () => WorkspaceSlugAuditsRouteRoute,
  } as any)
const WorkspaceSlugAdminActionsRouteRoute =
  WorkspaceSlugAdminActionsRouteRouteImport.update({
    id: '/actions',
    path: '/actions',
    getParentRoute: () => WorkspaceSlugAdminRouteRoute,
  } as any)
const WorkspaceSlugAuditsNewIndexRoute =
  WorkspaceSlugAuditsNewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceSlugAuditsNewRouteRoute,
  } as any)
const WorkspaceSlugAuditsAuditIdIndexRoute =
  WorkspaceSlugAuditsAuditIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceSlugAuditsAuditIdRouteRoute,
  } as any)
const WorkspaceSlugAdminStandardsIndexRoute =
  WorkspaceSlugAdminStandardsIndexRouteImport.update({
    id: '/standards/',
    path: '/standards/',
    getParentRoute: () => WorkspaceSlugAdminRouteRoute,
  } as any)
const WorkspaceSlugAdminActionsIndexRoute =
  WorkspaceSlugAdminActionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceSlugAdminActionsRouteRoute,
  } as any)
const WorkspaceSlugAdminStandardsStandardIdRoute =
  WorkspaceSlugAdminStandardsStandardIdRouteImport.update({
    id: '/standards/$standardId',
    path: '/standards/$standardId',
    getParentRoute: () => WorkspaceSlugAdminRouteRoute,
  } as any)
const WorkspaceSlugAuditsAuditIdChecklistIndexRoute =
  WorkspaceSlugAuditsAuditIdChecklistIndexRouteImport.update({
    id: '/checklist/',
    path: '/checklist/',
    getParentRoute: () => WorkspaceSlugAuditsAuditIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$workspaceSlug': typeof WorkspaceSlugRouteRouteWithChildren
  '/dev': typeof DevRouteRouteWithChildren
  '/auth': typeof AuthRoute
  '/onboarding': typeof OnboardingRoute
  '/$workspaceSlug/admin': typeof WorkspaceSlugAdminRouteRouteWithChildren
  '/$workspaceSlug/audits': typeof WorkspaceSlugAuditsRouteRouteWithChildren
  '/$workspaceSlug/documents': typeof WorkspaceSlugDocumentsRouteRouteWithChildren
  '/$workspaceSlug/settings': typeof WorkspaceSlugSettingsRouteRouteWithChildren
  '/$workspaceSlug/dashboard': typeof WorkspaceSlugDashboardRoute
  '/$workspaceSlug/inbox': typeof WorkspaceSlugInboxRoute
  '/dev/audits': typeof DevAuditsRoute
  '/dev/checklist': typeof DevChecklistRoute
  '/dev/documents': typeof DevDocumentsRoute
  '/dev/notifications': typeof DevNotificationsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/$workspaceSlug/': typeof WorkspaceSlugIndexRoute
  '/dev/': typeof DevIndexRoute
  '/$workspaceSlug/admin/actions': typeof WorkspaceSlugAdminActionsRouteRouteWithChildren
  '/$workspaceSlug/audits/$auditId': typeof WorkspaceSlugAuditsAuditIdRouteRouteWithChildren
  '/$workspaceSlug/audits/new': typeof WorkspaceSlugAuditsNewRouteRouteWithChildren
  '/$workspaceSlug/documents/$documentId': typeof WorkspaceSlugDocumentsDocumentIdRoute
  '/$workspaceSlug/settings/ai-provider': typeof WorkspaceSlugSettingsAiProviderRoute
  '/$workspaceSlug/settings/ai-rules': typeof WorkspaceSlugSettingsAiRulesRoute
  '/$workspaceSlug/settings/ai-usage': typeof WorkspaceSlugSettingsAiUsageRoute
  '/$workspaceSlug/settings/audit-config': typeof WorkspaceSlugSettingsAuditConfigRoute
  '/$workspaceSlug/settings/audit-tags': typeof WorkspaceSlugSettingsAuditTagsRoute
  '/$workspaceSlug/settings/billing': typeof WorkspaceSlugSettingsBillingRoute
  '/$workspaceSlug/settings/categories': typeof WorkspaceSlugSettingsCategoriesRoute
  '/$workspaceSlug/settings/integrations': typeof WorkspaceSlugSettingsIntegrationsRoute
  '/$workspaceSlug/settings/notifications': typeof WorkspaceSlugSettingsNotificationsRoute
  '/$workspaceSlug/settings/profile': typeof WorkspaceSlugSettingsProfileRoute
  '/$workspaceSlug/settings/security': typeof WorkspaceSlugSettingsSecurityRoute
  '/$workspaceSlug/settings/tags': typeof WorkspaceSlugSettingsTagsRoute
  '/$workspaceSlug/settings/workspace': typeof WorkspaceSlugSettingsWorkspaceRoute
  '/$workspaceSlug/standards/$standardId': typeof WorkspaceSlugStandardsStandardIdRoute
  '/$workspaceSlug/audits/': typeof WorkspaceSlugAuditsIndexRoute
  '/$workspaceSlug/documents/': typeof WorkspaceSlugDocumentsIndexRoute
  '/$workspaceSlug/reports/': typeof WorkspaceSlugReportsIndexRoute
  '/$workspaceSlug/settings/': typeof WorkspaceSlugSettingsIndexRoute
  '/$workspaceSlug/standards/': typeof WorkspaceSlugStandardsIndexRoute
  '/$workspaceSlug/admin/standards/$standardId': typeof WorkspaceSlugAdminStandardsStandardIdRoute
  '/$workspaceSlug/admin/actions/': typeof WorkspaceSlugAdminActionsIndexRoute
  '/$workspaceSlug/admin/standards/': typeof WorkspaceSlugAdminStandardsIndexRoute
  '/$workspaceSlug/audits/$auditId/': typeof WorkspaceSlugAuditsAuditIdIndexRoute
  '/$workspaceSlug/audits/new/': typeof WorkspaceSlugAuditsNewIndexRoute
  '/$workspaceSlug/audits/$auditId/checklist/': typeof WorkspaceSlugAuditsAuditIdChecklistIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/onboarding': typeof OnboardingRoute
  '/$workspaceSlug/admin': typeof WorkspaceSlugAdminRouteRouteWithChildren
  '/$workspaceSlug/dashboard': typeof WorkspaceSlugDashboardRoute
  '/$workspaceSlug/inbox': typeof WorkspaceSlugInboxRoute
  '/dev/audits': typeof DevAuditsRoute
  '/dev/checklist': typeof DevChecklistRoute
  '/dev/documents': typeof DevDocumentsRoute
  '/dev/notifications': typeof DevNotificationsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/$workspaceSlug': typeof WorkspaceSlugIndexRoute
  '/dev': typeof DevIndexRoute
  '/$workspaceSlug/documents/$documentId': typeof WorkspaceSlugDocumentsDocumentIdRoute
  '/$workspaceSlug/settings/ai-provider': typeof WorkspaceSlugSettingsAiProviderRoute
  '/$workspaceSlug/settings/ai-rules': typeof WorkspaceSlugSettingsAiRulesRoute
  '/$workspaceSlug/settings/ai-usage': typeof WorkspaceSlugSettingsAiUsageRoute
  '/$workspaceSlug/settings/audit-config': typeof WorkspaceSlugSettingsAuditConfigRoute
  '/$workspaceSlug/settings/audit-tags': typeof WorkspaceSlugSettingsAuditTagsRoute
  '/$workspaceSlug/settings/billing': typeof WorkspaceSlugSettingsBillingRoute
  '/$workspaceSlug/settings/categories': typeof WorkspaceSlugSettingsCategoriesRoute
  '/$workspaceSlug/settings/integrations': typeof WorkspaceSlugSettingsIntegrationsRoute
  '/$workspaceSlug/settings/notifications': typeof WorkspaceSlugSettingsNotificationsRoute
  '/$workspaceSlug/settings/profile': typeof WorkspaceSlugSettingsProfileRoute
  '/$workspaceSlug/settings/security': typeof WorkspaceSlugSettingsSecurityRoute
  '/$workspaceSlug/settings/tags': typeof WorkspaceSlugSettingsTagsRoute
  '/$workspaceSlug/settings/workspace': typeof WorkspaceSlugSettingsWorkspaceRoute
  '/$workspaceSlug/standards/$standardId': typeof WorkspaceSlugStandardsStandardIdRoute
  '/$workspaceSlug/audits': typeof WorkspaceSlugAuditsIndexRoute
  '/$workspaceSlug/documents': typeof WorkspaceSlugDocumentsIndexRoute
  '/$workspaceSlug/reports': typeof WorkspaceSlugReportsIndexRoute
  '/$workspaceSlug/settings': typeof WorkspaceSlugSettingsIndexRoute
  '/$workspaceSlug/standards': typeof WorkspaceSlugStandardsIndexRoute
  '/$workspaceSlug/admin/standards/$standardId': typeof WorkspaceSlugAdminStandardsStandardIdRoute
  '/$workspaceSlug/admin/actions': typeof WorkspaceSlugAdminActionsIndexRoute
  '/$workspaceSlug/admin/standards': typeof WorkspaceSlugAdminStandardsIndexRoute
  '/$workspaceSlug/audits/$auditId': typeof WorkspaceSlugAuditsAuditIdIndexRoute
  '/$workspaceSlug/audits/new': typeof WorkspaceSlugAuditsNewIndexRoute
  '/$workspaceSlug/audits/$auditId/checklist': typeof WorkspaceSlugAuditsAuditIdChecklistIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$workspaceSlug': typeof WorkspaceSlugRouteRouteWithChildren
  '/dev': typeof DevRouteRouteWithChildren
  '/auth': typeof AuthRoute
  '/onboarding': typeof OnboardingRoute
  '/$workspaceSlug/admin': typeof WorkspaceSlugAdminRouteRouteWithChildren
  '/$workspaceSlug/audits': typeof WorkspaceSlugAuditsRouteRouteWithChildren
  '/$workspaceSlug/documents': typeof WorkspaceSlugDocumentsRouteRouteWithChildren
  '/$workspaceSlug/settings': typeof WorkspaceSlugSettingsRouteRouteWithChildren
  '/$workspaceSlug/dashboard': typeof WorkspaceSlugDashboardRoute
  '/$workspaceSlug/inbox': typeof WorkspaceSlugInboxRoute
  '/dev/audits': typeof DevAuditsRoute
  '/dev/checklist': typeof DevChecklistRoute
  '/dev/documents': typeof DevDocumentsRoute
  '/dev/notifications': typeof DevNotificationsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/$workspaceSlug/': typeof WorkspaceSlugIndexRoute
  '/dev/': typeof DevIndexRoute
  '/$workspaceSlug/admin/actions': typeof WorkspaceSlugAdminActionsRouteRouteWithChildren
  '/$workspaceSlug/audits/$auditId': typeof WorkspaceSlugAuditsAuditIdRouteRouteWithChildren
  '/$workspaceSlug/audits/new': typeof WorkspaceSlugAuditsNewRouteRouteWithChildren
  '/$workspaceSlug/documents/$documentId': typeof WorkspaceSlugDocumentsDocumentIdRoute
  '/$workspaceSlug/settings/ai-provider': typeof WorkspaceSlugSettingsAiProviderRoute
  '/$workspaceSlug/settings/ai-rules': typeof WorkspaceSlugSettingsAiRulesRoute
  '/$workspaceSlug/settings/ai-usage': typeof WorkspaceSlugSettingsAiUsageRoute
  '/$workspaceSlug/settings/audit-config': typeof WorkspaceSlugSettingsAuditConfigRoute
  '/$workspaceSlug/settings/audit-tags': typeof WorkspaceSlugSettingsAuditTagsRoute
  '/$workspaceSlug/settings/billing': typeof WorkspaceSlugSettingsBillingRoute
  '/$workspaceSlug/settings/categories': typeof WorkspaceSlugSettingsCategoriesRoute
  '/$workspaceSlug/settings/integrations': typeof WorkspaceSlugSettingsIntegrationsRoute
  '/$workspaceSlug/settings/notifications': typeof WorkspaceSlugSettingsNotificationsRoute
  '/$workspaceSlug/settings/profile': typeof WorkspaceSlugSettingsProfileRoute
  '/$workspaceSlug/settings/security': typeof WorkspaceSlugSettingsSecurityRoute
  '/$workspaceSlug/settings/tags': typeof WorkspaceSlugSettingsTagsRoute
  '/$workspaceSlug/settings/workspace': typeof WorkspaceSlugSettingsWorkspaceRoute
  '/$workspaceSlug/standards/$standardId': typeof WorkspaceSlugStandardsStandardIdRoute
  '/$workspaceSlug/audits/': typeof WorkspaceSlugAuditsIndexRoute
  '/$workspaceSlug/documents/': typeof WorkspaceSlugDocumentsIndexRoute
  '/$workspaceSlug/reports/': typeof WorkspaceSlugReportsIndexRoute
  '/$workspaceSlug/settings/': typeof WorkspaceSlugSettingsIndexRoute
  '/$workspaceSlug/standards/': typeof WorkspaceSlugStandardsIndexRoute
  '/$workspaceSlug/admin/standards/$standardId': typeof WorkspaceSlugAdminStandardsStandardIdRoute
  '/$workspaceSlug/admin/actions/': typeof WorkspaceSlugAdminActionsIndexRoute
  '/$workspaceSlug/admin/standards/': typeof WorkspaceSlugAdminStandardsIndexRoute
  '/$workspaceSlug/audits/$auditId/': typeof WorkspaceSlugAuditsAuditIdIndexRoute
  '/$workspaceSlug/audits/new/': typeof WorkspaceSlugAuditsNewIndexRoute
  '/$workspaceSlug/audits/$auditId/checklist/': typeof WorkspaceSlugAuditsAuditIdChecklistIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$workspaceSlug'
    | '/dev'
    | '/auth'
    | '/onboarding'
    | '/$workspaceSlug/admin'
    | '/$workspaceSlug/audits'
    | '/$workspaceSlug/documents'
    | '/$workspaceSlug/settings'
    | '/$workspaceSlug/dashboard'
    | '/$workspaceSlug/inbox'
    | '/dev/audits'
    | '/dev/checklist'
    | '/dev/documents'
    | '/dev/notifications'
    | '/invite/$token'
    | '/$workspaceSlug/'
    | '/dev/'
    | '/$workspaceSlug/admin/actions'
    | '/$workspaceSlug/audits/$auditId'
    | '/$workspaceSlug/audits/new'
    | '/$workspaceSlug/documents/$documentId'
    | '/$workspaceSlug/settings/ai-provider'
    | '/$workspaceSlug/settings/ai-rules'
    | '/$workspaceSlug/settings/ai-usage'
    | '/$workspaceSlug/settings/audit-config'
    | '/$workspaceSlug/settings/audit-tags'
    | '/$workspaceSlug/settings/billing'
    | '/$workspaceSlug/settings/categories'
    | '/$workspaceSlug/settings/integrations'
    | '/$workspaceSlug/settings/notifications'
    | '/$workspaceSlug/settings/profile'
    | '/$workspaceSlug/settings/security'
    | '/$workspaceSlug/settings/tags'
    | '/$workspaceSlug/settings/workspace'
    | '/$workspaceSlug/standards/$standardId'
    | '/$workspaceSlug/audits/'
    | '/$workspaceSlug/documents/'
    | '/$workspaceSlug/reports/'
    | '/$workspaceSlug/settings/'
    | '/$workspaceSlug/standards/'
    | '/$workspaceSlug/admin/standards/$standardId'
    | '/$workspaceSlug/admin/actions/'
    | '/$workspaceSlug/admin/standards/'
    | '/$workspaceSlug/audits/$auditId/'
    | '/$workspaceSlug/audits/new/'
    | '/$workspaceSlug/audits/$auditId/checklist/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/onboarding'
    | '/$workspaceSlug/admin'
    | '/$workspaceSlug/dashboard'
    | '/$workspaceSlug/inbox'
    | '/dev/audits'
    | '/dev/checklist'
    | '/dev/documents'
    | '/dev/notifications'
    | '/invite/$token'
    | '/$workspaceSlug'
    | '/dev'
    | '/$workspaceSlug/documents/$documentId'
    | '/$workspaceSlug/settings/ai-provider'
    | '/$workspaceSlug/settings/ai-rules'
    | '/$workspaceSlug/settings/ai-usage'
    | '/$workspaceSlug/settings/audit-config'
    | '/$workspaceSlug/settings/audit-tags'
    | '/$workspaceSlug/settings/billing'
    | '/$workspaceSlug/settings/categories'
    | '/$workspaceSlug/settings/integrations'
    | '/$workspaceSlug/settings/notifications'
    | '/$workspaceSlug/settings/profile'
    | '/$workspaceSlug/settings/security'
    | '/$workspaceSlug/settings/tags'
    | '/$workspaceSlug/settings/workspace'
    | '/$workspaceSlug/standards/$standardId'
    | '/$workspaceSlug/audits'
    | '/$workspaceSlug/documents'
    | '/$workspaceSlug/reports'
    | '/$workspaceSlug/settings'
    | '/$workspaceSlug/standards'
    | '/$workspaceSlug/admin/standards/$standardId'
    | '/$workspaceSlug/admin/actions'
    | '/$workspaceSlug/admin/standards'
    | '/$workspaceSlug/audits/$auditId'
    | '/$workspaceSlug/audits/new'
    | '/$workspaceSlug/audits/$auditId/checklist'
  id:
    | '__root__'
    | '/'
    | '/$workspaceSlug'
    | '/dev'
    | '/auth'
    | '/onboarding'
    | '/$workspaceSlug/admin'
    | '/$workspaceSlug/audits'
    | '/$workspaceSlug/documents'
    | '/$workspaceSlug/settings'
    | '/$workspaceSlug/dashboard'
    | '/$workspaceSlug/inbox'
    | '/dev/audits'
    | '/dev/checklist'
    | '/dev/documents'
    | '/dev/notifications'
    | '/invite/$token'
    | '/$workspaceSlug/'
    | '/dev/'
    | '/$workspaceSlug/admin/actions'
    | '/$workspaceSlug/audits/$auditId'
    | '/$workspaceSlug/audits/new'
    | '/$workspaceSlug/documents/$documentId'
    | '/$workspaceSlug/settings/ai-provider'
    | '/$workspaceSlug/settings/ai-rules'
    | '/$workspaceSlug/settings/ai-usage'
    | '/$workspaceSlug/settings/audit-config'
    | '/$workspaceSlug/settings/audit-tags'
    | '/$workspaceSlug/settings/billing'
    | '/$workspaceSlug/settings/categories'
    | '/$workspaceSlug/settings/integrations'
    | '/$workspaceSlug/settings/notifications'
    | '/$workspaceSlug/settings/profile'
    | '/$workspaceSlug/settings/security'
    | '/$workspaceSlug/settings/tags'
    | '/$workspaceSlug/settings/workspace'
    | '/$workspaceSlug/standards/$standardId'
    | '/$workspaceSlug/audits/'
    | '/$workspaceSlug/documents/'
    | '/$workspaceSlug/reports/'
    | '/$workspaceSlug/settings/'
    | '/$workspaceSlug/standards/'
    | '/$workspaceSlug/admin/standards/$standardId'
    | '/$workspaceSlug/admin/actions/'
    | '/$workspaceSlug/admin/standards/'
    | '/$workspaceSlug/audits/$auditId/'
    | '/$workspaceSlug/audits/new/'
    | '/$workspaceSlug/audits/$auditId/checklist/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  WorkspaceSlugRouteRoute: typeof WorkspaceSlugRouteRouteWithChildren
  DevRouteRoute: typeof DevRouteRouteWithChildren
  AuthRoute: typeof AuthRoute
  OnboardingRoute: typeof OnboardingRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev': {
      id: '/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof DevRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$workspaceSlug': {
      id: '/$workspaceSlug'
      path: '/$workspaceSlug'
      fullPath: '/$workspaceSlug'
      preLoaderRoute: typeof WorkspaceSlugRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/': {
      id: '/dev/'
      path: '/'
      fullPath: '/dev/'
      preLoaderRoute: typeof DevIndexRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/$workspaceSlug/': {
      id: '/$workspaceSlug/'
      path: '/'
      fullPath: '/$workspaceSlug/'
      preLoaderRoute: typeof WorkspaceSlugIndexRouteImport
      parentRoute: typeof WorkspaceSlugRouteRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/notifications': {
      id: '/dev/notifications'
      path: '/notifications'
      fullPath: '/dev/notifications'
      preLoaderRoute: typeof DevNotificationsRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dev/documents': {
      id: '/dev/documents'
      path: '/documents'
      fullPath: '/dev/documents'
      preLoaderRoute: typeof DevDocumentsRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dev/checklist': {
      id: '/dev/checklist'
      path: '/checklist'
      fullPath: '/dev/checklist'
      preLoaderRoute: typeof DevChecklistRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dev/audits': {
      id: '/dev/audits'
      path: '/audits'
      fullPath: '/dev/audits'
      preLoaderRoute: typeof DevAuditsRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/$workspaceSlug/inbox': {
      id: '/$workspaceSlug/inbox'
      path: '/inbox'
      fullPath: '/$workspaceSlug/inbox'
      preLoaderRoute: typeof WorkspaceSlugInboxRouteImport
      parentRoute: typeof WorkspaceSlugRouteRoute
    }
    '/$workspaceSlug/dashboard': {
      id: '/$workspaceSlug/dashboard'
      path: '/dashboard'
      fullPath: '/$workspaceSlug/dashboard'
      preLoaderRoute: typeof WorkspaceSlugDashboardRouteImport
      parentRoute: typeof WorkspaceSlugRouteRoute
    }
    '/$workspaceSlug/settings': {
      id: '/$workspaceSlug/settings'
      path: '/settings'
      fullPath: '/$workspaceSlug/settings'
      preLoaderRoute: typeof WorkspaceSlugSettingsRouteRouteImport
      parentRoute: typeof WorkspaceSlugRouteRoute
    }
    '/$workspaceSlug/documents': {
      id: '/$workspaceSlug/documents'
      path: '/documents'
      fullPath: '/$workspaceSlug/documents'
      preLoaderRoute: typeof WorkspaceSlugDocumentsRouteRouteImport
      parentRoute: typeof WorkspaceSlugRouteRoute
    }
    '/$workspaceSlug/audits': {
      id: '/$workspaceSlug/audits'
      path: '/audits'
      fullPath: '/$workspaceSlug/audits'
      preLoaderRoute: typeof WorkspaceSlugAuditsRouteRouteImport
      parentRoute: typeof WorkspaceSlugRouteRoute
    }
    '/$workspaceSlug/admin': {
      id: '/$workspaceSlug/admin'
      path: '/admin'
      fullPath: '/$workspaceSlug/admin'
      preLoaderRoute: typeof WorkspaceSlugAdminRouteRouteImport
      parentRoute: typeof WorkspaceSlugRouteRoute
    }
    '/$workspaceSlug/standards/': {
      id: '/$workspaceSlug/standards/'
      path: '/standards'
      fullPath: '/$workspaceSlug/standards/'
      preLoaderRoute: typeof WorkspaceSlugStandardsIndexRouteImport
      parentRoute: typeof WorkspaceSlugRouteRoute
    }
    '/$workspaceSlug/settings/': {
      id: '/$workspaceSlug/settings/'
      path: '/'
      fullPath: '/$workspaceSlug/settings/'
      preLoaderRoute: typeof WorkspaceSlugSettingsIndexRouteImport
      parentRoute: typeof WorkspaceSlugSettingsRouteRoute
    }
    '/$workspaceSlug/reports/': {
      id: '/$workspaceSlug/reports/'
      path: '/reports'
      fullPath: '/$workspaceSlug/reports/'
      preLoaderRoute: typeof WorkspaceSlugReportsIndexRouteImport
      parentRoute: typeof WorkspaceSlugRouteRoute
    }
    '/$workspaceSlug/documents/': {
      id: '/$workspaceSlug/documents/'
      path: '/'
      fullPath: '/$workspaceSlug/documents/'
      preLoaderRoute: typeof WorkspaceSlugDocumentsIndexRouteImport
      parentRoute: typeof WorkspaceSlugDocumentsRouteRoute
    }
    '/$workspaceSlug/audits/': {
      id: '/$workspaceSlug/audits/'
      path: '/'
      fullPath: '/$workspaceSlug/audits/'
      preLoaderRoute: typeof WorkspaceSlugAuditsIndexRouteImport
      parentRoute: typeof WorkspaceSlugAuditsRouteRoute
    }
    '/$workspaceSlug/standards/$standardId': {
      id: '/$workspaceSlug/standards/$standardId'
      path: '/standards/$standardId'
      fullPath: '/$workspaceSlug/standards/$standardId'
      preLoaderRoute: typeof WorkspaceSlugStandardsStandardIdRouteImport
      parentRoute: typeof WorkspaceSlugRouteRoute
    }
    '/$workspaceSlug/settings/workspace': {
      id: '/$workspaceSlug/settings/workspace'
      path: '/workspace'
      fullPath: '/$workspaceSlug/settings/workspace'
      preLoaderRoute: typeof WorkspaceSlugSettingsWorkspaceRouteImport
      parentRoute: typeof WorkspaceSlugSettingsRouteRoute
    }
    '/$workspaceSlug/settings/tags': {
      id: '/$workspaceSlug/settings/tags'
      path: '/tags'
      fullPath: '/$workspaceSlug/settings/tags'
      preLoaderRoute: typeof WorkspaceSlugSettingsTagsRouteImport
      parentRoute: typeof WorkspaceSlugSettingsRouteRoute
    }
    '/$workspaceSlug/settings/security': {
      id: '/$workspaceSlug/settings/security'
      path: '/security'
      fullPath: '/$workspaceSlug/settings/security'
      preLoaderRoute: typeof WorkspaceSlugSettingsSecurityRouteImport
      parentRoute: typeof WorkspaceSlugSettingsRouteRoute
    }
    '/$workspaceSlug/settings/profile': {
      id: '/$workspaceSlug/settings/profile'
      path: '/profile'
      fullPath: '/$workspaceSlug/settings/profile'
      preLoaderRoute: typeof WorkspaceSlugSettingsProfileRouteImport
      parentRoute: typeof WorkspaceSlugSettingsRouteRoute
    }
    '/$workspaceSlug/settings/notifications': {
      id: '/$workspaceSlug/settings/notifications'
      path: '/notifications'
      fullPath: '/$workspaceSlug/settings/notifications'
      preLoaderRoute: typeof WorkspaceSlugSettingsNotificationsRouteImport
      parentRoute: typeof WorkspaceSlugSettingsRouteRoute
    }
    '/$workspaceSlug/settings/integrations': {
      id: '/$workspaceSlug/settings/integrations'
      path: '/integrations'
      fullPath: '/$workspaceSlug/settings/integrations'
      preLoaderRoute: typeof WorkspaceSlugSettingsIntegrationsRouteImport
      parentRoute: typeof WorkspaceSlugSettingsRouteRoute
    }
    '/$workspaceSlug/settings/categories': {
      id: '/$workspaceSlug/settings/categories'
      path: '/categories'
      fullPath: '/$workspaceSlug/settings/categories'
      preLoaderRoute: typeof WorkspaceSlugSettingsCategoriesRouteImport
      parentRoute: typeof WorkspaceSlugSettingsRouteRoute
    }
    '/$workspaceSlug/settings/billing': {
      id: '/$workspaceSlug/settings/billing'
      path: '/billing'
      fullPath: '/$workspaceSlug/settings/billing'
      preLoaderRoute: typeof WorkspaceSlugSettingsBillingRouteImport
      parentRoute: typeof WorkspaceSlugSettingsRouteRoute
    }
    '/$workspaceSlug/settings/audit-tags': {
      id: '/$workspaceSlug/settings/audit-tags'
      path: '/audit-tags'
      fullPath: '/$workspaceSlug/settings/audit-tags'
      preLoaderRoute: typeof WorkspaceSlugSettingsAuditTagsRouteImport
      parentRoute: typeof WorkspaceSlugSettingsRouteRoute
    }
    '/$workspaceSlug/settings/audit-config': {
      id: '/$workspaceSlug/settings/audit-config'
      path: '/audit-config'
      fullPath: '/$workspaceSlug/settings/audit-config'
      preLoaderRoute: typeof WorkspaceSlugSettingsAuditConfigRouteImport
      parentRoute: typeof WorkspaceSlugSettingsRouteRoute
    }
    '/$workspaceSlug/settings/ai-usage': {
      id: '/$workspaceSlug/settings/ai-usage'
      path: '/ai-usage'
      fullPath: '/$workspaceSlug/settings/ai-usage'
      preLoaderRoute: typeof WorkspaceSlugSettingsAiUsageRouteImport
      parentRoute: typeof WorkspaceSlugSettingsRouteRoute
    }
    '/$workspaceSlug/settings/ai-rules': {
      id: '/$workspaceSlug/settings/ai-rules'
      path: '/ai-rules'
      fullPath: '/$workspaceSlug/settings/ai-rules'
      preLoaderRoute: typeof WorkspaceSlugSettingsAiRulesRouteImport
      parentRoute: typeof WorkspaceSlugSettingsRouteRoute
    }
    '/$workspaceSlug/settings/ai-provider': {
      id: '/$workspaceSlug/settings/ai-provider'
      path: '/ai-provider'
      fullPath: '/$workspaceSlug/settings/ai-provider'
      preLoaderRoute: typeof WorkspaceSlugSettingsAiProviderRouteImport
      parentRoute: typeof WorkspaceSlugSettingsRouteRoute
    }
    '/$workspaceSlug/documents/$documentId': {
      id: '/$workspaceSlug/documents/$documentId'
      path: '/$documentId'
      fullPath: '/$workspaceSlug/documents/$documentId'
      preLoaderRoute: typeof WorkspaceSlugDocumentsDocumentIdRouteImport
      parentRoute: typeof WorkspaceSlugDocumentsRouteRoute
    }
    '/$workspaceSlug/audits/new': {
      id: '/$workspaceSlug/audits/new'
      path: '/new'
      fullPath: '/$workspaceSlug/audits/new'
      preLoaderRoute: typeof WorkspaceSlugAuditsNewRouteRouteImport
      parentRoute: typeof WorkspaceSlugAuditsRouteRoute
    }
    '/$workspaceSlug/audits/$auditId': {
      id: '/$workspaceSlug/audits/$auditId'
      path: '/$auditId'
      fullPath: '/$workspaceSlug/audits/$auditId'
      preLoaderRoute: typeof WorkspaceSlugAuditsAuditIdRouteRouteImport
      parentRoute: typeof WorkspaceSlugAuditsRouteRoute
    }
    '/$workspaceSlug/admin/actions': {
      id: '/$workspaceSlug/admin/actions'
      path: '/actions'
      fullPath: '/$workspaceSlug/admin/actions'
      preLoaderRoute: typeof WorkspaceSlugAdminActionsRouteRouteImport
      parentRoute: typeof WorkspaceSlugAdminRouteRoute
    }
    '/$workspaceSlug/audits/new/': {
      id: '/$workspaceSlug/audits/new/'
      path: '/'
      fullPath: '/$workspaceSlug/audits/new/'
      preLoaderRoute: typeof WorkspaceSlugAuditsNewIndexRouteImport
      parentRoute: typeof WorkspaceSlugAuditsNewRouteRoute
    }
    '/$workspaceSlug/audits/$auditId/': {
      id: '/$workspaceSlug/audits/$auditId/'
      path: '/'
      fullPath: '/$workspaceSlug/audits/$auditId/'
      preLoaderRoute: typeof WorkspaceSlugAuditsAuditIdIndexRouteImport
      parentRoute: typeof WorkspaceSlugAuditsAuditIdRouteRoute
    }
    '/$workspaceSlug/admin/standards/': {
      id: '/$workspaceSlug/admin/standards/'
      path: '/standards'
      fullPath: '/$workspaceSlug/admin/standards/'
      preLoaderRoute: typeof WorkspaceSlugAdminStandardsIndexRouteImport
      parentRoute: typeof WorkspaceSlugAdminRouteRoute
    }
    '/$workspaceSlug/admin/actions/': {
      id: '/$workspaceSlug/admin/actions/'
      path: '/'
      fullPath: '/$workspaceSlug/admin/actions/'
      preLoaderRoute: typeof WorkspaceSlugAdminActionsIndexRouteImport
      parentRoute: typeof WorkspaceSlugAdminActionsRouteRoute
    }
    '/$workspaceSlug/admin/standards/$standardId': {
      id: '/$workspaceSlug/admin/standards/$standardId'
      path: '/standards/$standardId'
      fullPath: '/$workspaceSlug/admin/standards/$standardId'
      preLoaderRoute: typeof WorkspaceSlugAdminStandardsStandardIdRouteImport
      parentRoute: typeof WorkspaceSlugAdminRouteRoute
    }
    '/$workspaceSlug/audits/$auditId/checklist/': {
      id: '/$workspaceSlug/audits/$auditId/checklist/'
      path: '/checklist'
      fullPath: '/$workspaceSlug/audits/$auditId/checklist/'
      preLoaderRoute: typeof WorkspaceSlugAuditsAuditIdChecklistIndexRouteImport
      parentRoute: typeof WorkspaceSlugAuditsAuditIdRouteRoute
    }
  }
}

interface WorkspaceSlugAdminActionsRouteRouteChildren {
  WorkspaceSlugAdminActionsIndexRoute: typeof WorkspaceSlugAdminActionsIndexRoute
}

const WorkspaceSlugAdminActionsRouteRouteChildren: WorkspaceSlugAdminActionsRouteRouteChildren =
  {
    WorkspaceSlugAdminActionsIndexRoute: WorkspaceSlugAdminActionsIndexRoute,
  }

const WorkspaceSlugAdminActionsRouteRouteWithChildren =
  WorkspaceSlugAdminActionsRouteRoute._addFileChildren(
    WorkspaceSlugAdminActionsRouteRouteChildren,
  )

interface WorkspaceSlugAdminRouteRouteChildren {
  WorkspaceSlugAdminActionsRouteRoute: typeof WorkspaceSlugAdminActionsRouteRouteWithChildren
  WorkspaceSlugAdminStandardsStandardIdRoute: typeof WorkspaceSlugAdminStandardsStandardIdRoute
  WorkspaceSlugAdminStandardsIndexRoute: typeof WorkspaceSlugAdminStandardsIndexRoute
}

const WorkspaceSlugAdminRouteRouteChildren: WorkspaceSlugAdminRouteRouteChildren =
  {
    WorkspaceSlugAdminActionsRouteRoute:
      WorkspaceSlugAdminActionsRouteRouteWithChildren,
    WorkspaceSlugAdminStandardsStandardIdRoute:
      WorkspaceSlugAdminStandardsStandardIdRoute,
    WorkspaceSlugAdminStandardsIndexRoute:
      WorkspaceSlugAdminStandardsIndexRoute,
  }

const WorkspaceSlugAdminRouteRouteWithChildren =
  WorkspaceSlugAdminRouteRoute._addFileChildren(
    WorkspaceSlugAdminRouteRouteChildren,
  )

interface WorkspaceSlugAuditsAuditIdRouteRouteChildren {
  WorkspaceSlugAuditsAuditIdIndexRoute: typeof WorkspaceSlugAuditsAuditIdIndexRoute
  WorkspaceSlugAuditsAuditIdChecklistIndexRoute: typeof WorkspaceSlugAuditsAuditIdChecklistIndexRoute
}

const WorkspaceSlugAuditsAuditIdRouteRouteChildren: WorkspaceSlugAuditsAuditIdRouteRouteChildren =
  {
    WorkspaceSlugAuditsAuditIdIndexRoute: WorkspaceSlugAuditsAuditIdIndexRoute,
    WorkspaceSlugAuditsAuditIdChecklistIndexRoute:
      WorkspaceSlugAuditsAuditIdChecklistIndexRoute,
  }

const WorkspaceSlugAuditsAuditIdRouteRouteWithChildren =
  WorkspaceSlugAuditsAuditIdRouteRoute._addFileChildren(
    WorkspaceSlugAuditsAuditIdRouteRouteChildren,
  )

interface WorkspaceSlugAuditsNewRouteRouteChildren {
  WorkspaceSlugAuditsNewIndexRoute: typeof WorkspaceSlugAuditsNewIndexRoute
}

const WorkspaceSlugAuditsNewRouteRouteChildren: WorkspaceSlugAuditsNewRouteRouteChildren =
  {
    WorkspaceSlugAuditsNewIndexRoute: WorkspaceSlugAuditsNewIndexRoute,
  }

const WorkspaceSlugAuditsNewRouteRouteWithChildren =
  WorkspaceSlugAuditsNewRouteRoute._addFileChildren(
    WorkspaceSlugAuditsNewRouteRouteChildren,
  )

interface WorkspaceSlugAuditsRouteRouteChildren {
  WorkspaceSlugAuditsAuditIdRouteRoute: typeof WorkspaceSlugAuditsAuditIdRouteRouteWithChildren
  WorkspaceSlugAuditsNewRouteRoute: typeof WorkspaceSlugAuditsNewRouteRouteWithChildren
  WorkspaceSlugAuditsIndexRoute: typeof WorkspaceSlugAuditsIndexRoute
}

const WorkspaceSlugAuditsRouteRouteChildren: WorkspaceSlugAuditsRouteRouteChildren =
  {
    WorkspaceSlugAuditsAuditIdRouteRoute:
      WorkspaceSlugAuditsAuditIdRouteRouteWithChildren,
    WorkspaceSlugAuditsNewRouteRoute:
      WorkspaceSlugAuditsNewRouteRouteWithChildren,
    WorkspaceSlugAuditsIndexRoute: WorkspaceSlugAuditsIndexRoute,
  }

const WorkspaceSlugAuditsRouteRouteWithChildren =
  WorkspaceSlugAuditsRouteRoute._addFileChildren(
    WorkspaceSlugAuditsRouteRouteChildren,
  )

interface WorkspaceSlugDocumentsRouteRouteChildren {
  WorkspaceSlugDocumentsDocumentIdRoute: typeof WorkspaceSlugDocumentsDocumentIdRoute
  WorkspaceSlugDocumentsIndexRoute: typeof WorkspaceSlugDocumentsIndexRoute
}

const WorkspaceSlugDocumentsRouteRouteChildren: WorkspaceSlugDocumentsRouteRouteChildren =
  {
    WorkspaceSlugDocumentsDocumentIdRoute:
      WorkspaceSlugDocumentsDocumentIdRoute,
    WorkspaceSlugDocumentsIndexRoute: WorkspaceSlugDocumentsIndexRoute,
  }

const WorkspaceSlugDocumentsRouteRouteWithChildren =
  WorkspaceSlugDocumentsRouteRoute._addFileChildren(
    WorkspaceSlugDocumentsRouteRouteChildren,
  )

interface WorkspaceSlugSettingsRouteRouteChildren {
  WorkspaceSlugSettingsAiProviderRoute: typeof WorkspaceSlugSettingsAiProviderRoute
  WorkspaceSlugSettingsAiRulesRoute: typeof WorkspaceSlugSettingsAiRulesRoute
  WorkspaceSlugSettingsAiUsageRoute: typeof WorkspaceSlugSettingsAiUsageRoute
  WorkspaceSlugSettingsAuditConfigRoute: typeof WorkspaceSlugSettingsAuditConfigRoute
  WorkspaceSlugSettingsAuditTagsRoute: typeof WorkspaceSlugSettingsAuditTagsRoute
  WorkspaceSlugSettingsBillingRoute: typeof WorkspaceSlugSettingsBillingRoute
  WorkspaceSlugSettingsCategoriesRoute: typeof WorkspaceSlugSettingsCategoriesRoute
  WorkspaceSlugSettingsIntegrationsRoute: typeof WorkspaceSlugSettingsIntegrationsRoute
  WorkspaceSlugSettingsNotificationsRoute: typeof WorkspaceSlugSettingsNotificationsRoute
  WorkspaceSlugSettingsProfileRoute: typeof WorkspaceSlugSettingsProfileRoute
  WorkspaceSlugSettingsSecurityRoute: typeof WorkspaceSlugSettingsSecurityRoute
  WorkspaceSlugSettingsTagsRoute: typeof WorkspaceSlugSettingsTagsRoute
  WorkspaceSlugSettingsWorkspaceRoute: typeof WorkspaceSlugSettingsWorkspaceRoute
  WorkspaceSlugSettingsIndexRoute: typeof WorkspaceSlugSettingsIndexRoute
}

const WorkspaceSlugSettingsRouteRouteChildren: WorkspaceSlugSettingsRouteRouteChildren =
  {
    WorkspaceSlugSettingsAiProviderRoute: WorkspaceSlugSettingsAiProviderRoute,
    WorkspaceSlugSettingsAiRulesRoute: WorkspaceSlugSettingsAiRulesRoute,
    WorkspaceSlugSettingsAiUsageRoute: WorkspaceSlugSettingsAiUsageRoute,
    WorkspaceSlugSettingsAuditConfigRoute:
      WorkspaceSlugSettingsAuditConfigRoute,
    WorkspaceSlugSettingsAuditTagsRoute: WorkspaceSlugSettingsAuditTagsRoute,
    WorkspaceSlugSettingsBillingRoute: WorkspaceSlugSettingsBillingRoute,
    WorkspaceSlugSettingsCategoriesRoute: WorkspaceSlugSettingsCategoriesRoute,
    WorkspaceSlugSettingsIntegrationsRoute:
      WorkspaceSlugSettingsIntegrationsRoute,
    WorkspaceSlugSettingsNotificationsRoute:
      WorkspaceSlugSettingsNotificationsRoute,
    WorkspaceSlugSettingsProfileRoute: WorkspaceSlugSettingsProfileRoute,
    WorkspaceSlugSettingsSecurityRoute: WorkspaceSlugSettingsSecurityRoute,
    WorkspaceSlugSettingsTagsRoute: WorkspaceSlugSettingsTagsRoute,
    WorkspaceSlugSettingsWorkspaceRoute: WorkspaceSlugSettingsWorkspaceRoute,
    WorkspaceSlugSettingsIndexRoute: WorkspaceSlugSettingsIndexRoute,
  }

const WorkspaceSlugSettingsRouteRouteWithChildren =
  WorkspaceSlugSettingsRouteRoute._addFileChildren(
    WorkspaceSlugSettingsRouteRouteChildren,
  )

interface WorkspaceSlugRouteRouteChildren {
  WorkspaceSlugAdminRouteRoute: typeof WorkspaceSlugAdminRouteRouteWithChildren
  WorkspaceSlugAuditsRouteRoute: typeof WorkspaceSlugAuditsRouteRouteWithChildren
  WorkspaceSlugDocumentsRouteRoute: typeof WorkspaceSlugDocumentsRouteRouteWithChildren
  WorkspaceSlugSettingsRouteRoute: typeof WorkspaceSlugSettingsRouteRouteWithChildren
  WorkspaceSlugDashboardRoute: typeof WorkspaceSlugDashboardRoute
  WorkspaceSlugInboxRoute: typeof WorkspaceSlugInboxRoute
  WorkspaceSlugIndexRoute: typeof WorkspaceSlugIndexRoute
  WorkspaceSlugStandardsStandardIdRoute: typeof WorkspaceSlugStandardsStandardIdRoute
  WorkspaceSlugReportsIndexRoute: typeof WorkspaceSlugReportsIndexRoute
  WorkspaceSlugStandardsIndexRoute: typeof WorkspaceSlugStandardsIndexRoute
}

const WorkspaceSlugRouteRouteChildren: WorkspaceSlugRouteRouteChildren = {
  WorkspaceSlugAdminRouteRoute: WorkspaceSlugAdminRouteRouteWithChildren,
  WorkspaceSlugAuditsRouteRoute: WorkspaceSlugAuditsRouteRouteWithChildren,
  WorkspaceSlugDocumentsRouteRoute:
    WorkspaceSlugDocumentsRouteRouteWithChildren,
  WorkspaceSlugSettingsRouteRoute: WorkspaceSlugSettingsRouteRouteWithChildren,
  WorkspaceSlugDashboardRoute: WorkspaceSlugDashboardRoute,
  WorkspaceSlugInboxRoute: WorkspaceSlugInboxRoute,
  WorkspaceSlugIndexRoute: WorkspaceSlugIndexRoute,
  WorkspaceSlugStandardsStandardIdRoute: WorkspaceSlugStandardsStandardIdRoute,
  WorkspaceSlugReportsIndexRoute: WorkspaceSlugReportsIndexRoute,
  WorkspaceSlugStandardsIndexRoute: WorkspaceSlugStandardsIndexRoute,
}

const WorkspaceSlugRouteRouteWithChildren =
  WorkspaceSlugRouteRoute._addFileChildren(WorkspaceSlugRouteRouteChildren)

interface DevRouteRouteChildren {
  DevAuditsRoute: typeof DevAuditsRoute
  DevChecklistRoute: typeof DevChecklistRoute
  DevDocumentsRoute: typeof DevDocumentsRoute
  DevNotificationsRoute: typeof DevNotificationsRoute
  DevIndexRoute: typeof DevIndexRoute
}

const DevRouteRouteChildren: DevRouteRouteChildren = {
  DevAuditsRoute: DevAuditsRoute,
  DevChecklistRoute: DevChecklistRoute,
  DevDocumentsRoute: DevDocumentsRoute,
  DevNotificationsRoute: DevNotificationsRoute,
  DevIndexRoute: DevIndexRoute,
}

const DevRouteRouteWithChildren = DevRouteRoute._addFileChildren(
  DevRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  WorkspaceSlugRouteRoute: WorkspaceSlugRouteRouteWithChildren,
  DevRouteRoute: DevRouteRouteWithChildren,
  AuthRoute: AuthRoute,
  OnboardingRoute: OnboardingRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
